// What a page shows while its data loads, or when loading failed.
//   if (q.isPending) return <Loading />;
//   if (q.isError) return <PageError error={q.error} />;
import { Link } from "react-router";
import { ApiError } from "../api/client";
import { Notice } from "./Notice";
import { PageHeader } from "./PageHeader";

export function Loading({ label = "Loading…" }: { label?: string }) {
  return (
    <p className="loading" role="status" aria-busy="true">
      {label}
    </p>
  );
}

export function NotFoundContent() {
  return (
    <>
      <PageHeader title="Page not found" />
      <p>The page may have been moved, or you may not have access to it.</p>
      <p>
        <Link to="/">Go to your start page</Link>
      </p>
    </>
  );
}

/** A 404 from the API shows the Not found page; anything else an error notice. */
export function PageError({ error }: { error: unknown }) {
  if (error instanceof ApiError && error.status === 404) return <NotFoundContent />;
  const message = error instanceof ApiError ? error.message : "Something went wrong. Please try again.";
  return (
    <Notice kind="error" title="This page could not be loaded">
      <p>{message}</p>
      <p>
        <a href={typeof window !== "undefined" ? window.location.href : "/"}>Reload the page</a>
      </p>
    </Notice>
  );
}
